export default __webpack_public_path__ + "static/media/rank-icon.03cd4b71.svg";